module.exports = __webpack_public_path__ + "static/media/U1-T1-6a.abd41c18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T1-6a.svg
// module id = 548
// module chunks = 0